import { Button, H1, H4, cn } from "@sorcery/ui";
import type { ReactNode } from "react";

export const FeatureTitle = ({
  title,
  subtitle,
  ctaText,
  ctaCallback,
  orientation = "center",
  className,
}: {
  title: string | ReactNode;
  subtitle?: string | ReactNode;
  ctaText?: string;
  ctaCallback?: () => void;
  orientation?: "left" | "center";
  className?: string;
}) => {
  return (
    <section
      className={cn(
        "sorcery-container sorcery-section !mb-0 duration-1000 animate-in fade-in",
        orientation === "center" ? "text-center" : "text-left",
      )}
    >
      <H1 className={cn("!mb-1 !mt-12 text-big-text-color sm:!mt-28 sm:!text-5xl", className)}>
        {title}
      </H1>
      {subtitle && <H4 className="!mb-0">{subtitle}</H4>}
      {ctaText && ctaCallback && (
        <Button variant="secondary" onClick={ctaCallback} className="my-2 w-fit font-title md:mb-4">
          {ctaText}
        </Button>
      )}
    </section>
  );
};
